import { faChevronDown } from '@fortawesome/free-solid-svg-icons/faChevronDown';
import { faChevronUp } from '@fortawesome/free-solid-svg-icons/faChevronUp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTheme } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { useTopLevelMenuStyles } from '../menuStyles/topLevelMenuStyles';

import { IMenuHeaderProps } from './menuHeaderProps';

export const IconMenuHeader = (props: IMenuHeaderProps) => {
  const theme = useTheme();
  const styles = useTopLevelMenuStyles(theme);
  const {
    ariaControls,
    icon,
    labelText,
    titleText,
    handleToggle,
    disableRipple,
    open,
    showChevron,
  } = props;

  return (
    <Tooltip title={titleText} placement="bottom-start">
      <IconButton
        data-testid="menu-button"
        className={`header-menu-button ${styles.iconButton}`}
        color="primary"
        aria-label={labelText}
        aria-controls={ariaControls}
        aria-haspopup="true"
        disableRipple={disableRipple}
        disableTouchRipple={disableRipple}
        disableFocusRipple={disableRipple}
        onClick={(e) => (handleToggle ? handleToggle(e) : null)}
      >
        {icon}

        {showChevron && (
          <FontAwesomeIcon className={styles.chevron} icon={open ? faChevronUp : faChevronDown} />
        )}
      </IconButton>
    </Tooltip>
  );
};
